function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M51.4,59.1h-29L11.2,36.6L7,26.8h9.3l5,4.2V0.8H33V16h8.7v4.3h8.7v4.3h7.6v19.1L51.4,59.1z M24.3,56.1h25.2l5.5-12.9 V27.7h-7.6v-4.3h-8.7V19H30V3.8h-5.7v33.7l-9.1-7.7h-3.7l2.4,5.5L24.3,56.1z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 30,
  y: 17,
  width: 3,
  height: 9.7
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 38.6,
  y: 19.1,
  width: 3,
  height: 9.7
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 47.3,
  y: 22.4,
  width: 3,
  height: 9.7
})))));

var SvgHand = function SvgHand(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/hand.2bb399b8.svg";
export { SvgHand as ReactComponent };